export default __webpack_public_path__ + "static/media/seventh.f953f39a.jpg";